import React from "react";
import _ from "lodash";
import Button from "Components/button/Button";
import QboxmailApi from "../../../qboxmailApi.js";
import DayPicker from "Components/dayPicker/DayPicker";
import Checkbox from "Components/checkbox/Checkbox";
import TranslatedString from "Components/TranslatedString";
import Divider from "Components/divider/Divider";
import DomainSelect from "Components/domainSelect/DomainSelect";
import FolderMapper from "Components/folderMapper/FolderMapper";
import XDate from "xdate";
import t from "Utils/translation";
import { alertSuccess } from "Utils/alerts";
import { formatServerErrors } from "Utils/serverFormats";
import WarningBanner from "Components/warningBanner/WarningBanner";

import cx from "classnames";
import s from "./settingsDelegates.scss";

export default class SettingsForm extends React.Component {
  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
    this.toggleNoExpiration = this.toggleNoExpiration.bind(this);
    this.toggleAlways = this.toggleAlways.bind(this);
    this.newDomainSelector = this.newDomainSelector.bind(this);
    this.updateStartDate = this.updateStartDate.bind(this);
    this.sendResetPwdEmail = this.sendResetPwdEmail.bind(this);
    this.updateExpiration = this.updateExpiration.bind(this);
    let date = new XDate();
    let organizedResources = {};
    let folderMapperValues = {};
    this.selectElements = {};
    this.mapperElements = {};
    let delegatedEmails = [];
    props.delegate.email_accounts.forEach((em) => {
      if (!organizedResources[em.domain_code]) {
        organizedResources[em.domain_code] = [];
      }

      if (!folderMapperValues[em.domain_code]) {
        folderMapperValues[em.domain_code] = {};
      }

      delegatedEmails.push(em.code);

      folderMapperValues[em.domain_code][em.email_address] = em.rights;

      organizedResources[em.domain_code].push({
        email_address: em.email_address,
        email_code: em.code,
        rights: em.rights,
      });
    });
    // assign email account that have no delegates
    props.domainsEmails.forEach((em) => {
      if (!delegatedEmails.includes(em.code)) {
        organizedResources[em.domain_code].push({
          email_address: em.email_address,
          email_code: em.code,
          rights: "ignore",
        });
      }
    });

    let selectorsValues = {};
    let index = 0;
    _.each(organizedResources, (em, code) => {
      selectorsValues[index] = { domainCode: code, emailAccounts: em };
      index += 1;
    });

    const api = new QboxmailApi({ useCookie: true });

    this.state = {
      tomorrow: date.addDays(1).toDate(),
      organizedResources,
      folderMapperValues,
      selectorsValues,
      api,
      resetPwdEmailSent: false,
    };
  }

  newDomainSelector() {
    let lastKey = _.last(Object.keys(this.state.selectorsValues)) || 0;
    this.setState({
      selectorsValues: {
        ...this.state.selectorsValues,
        [parseInt(lastKey) + 1]: {},
      },
    });
  }

  selectDomainAndLoadEmails(domainCode, domainSelectId) {
    let newState = {
      selectorsValues: {
        ...this.state.selectorsValues,
        [domainSelectId]: { domainCode, isLoadingEmails: true },
      },
      organizedResources: { ...this.state.organizedResources, [domainCode]: [] },
    };

    console.log("newState", newState);

    this.setState(newState);

    if (!domainCode) {
      let newState = {
        ...this.state,
        selectorsValues: {
          ...this.state.selectorsValues,
          [domainSelectId]: undefined,
        },
      };

      let deletedDomainCode = this.state.selectorsValues[domainSelectId].domainCode;
      delete newState.selectorsValues[domainSelectId];
      delete newState.organizedResources[deletedDomainCode];
      delete newState.folderMapperValues[deletedDomainCode];

      this.setState(newState);
      return false;
    }

    return this.state.api
      .getArchiveEmailAccounts(domainCode, { per: 10000, postmaster: true })
      .then((data) => {
        this.setState({
          selectorsValues: {
            ...this.state.selectorsValues,
            [domainSelectId]: {
              ...this.state.selectorsValues[domainSelectId],
              emailAccounts: data.resources.map((em) => ({
                email_address: em.email_address,
                email_code: em.code,
                rights: "ignore",
              })),
              isLoadingEmails: false,
            },
          },
        });
      })
      .catch((response) => {
        formatServerErrors(response).then((errors) => {
          this.props.setFormErrors(errors);
          this.props.unsetFormLoading();
        });
      });
  }

  submitForm() {
    const {
      refreshDelegate,
      unsetFormLoading,
      setFormErrors,
      match: {
        params: { delegateCode },
      },
      setFormLoading,
      formData,
    } = this.props;
    setFormLoading();

    let data = {};
    _.forEach(this.mapperElements, (el) => {
      if (el) {
        const d = _.omitBy(el.getValues(), (val) => val === false || val === "ignore" || val === undefined);

        data = { email_names: { ...d, ...data.email_names } };
      }
    });

    // map email_address with codes to send them to the backend
    let formattedData = {};
    Object.keys(data.email_names).forEach((emailName) => {
      _.each(this.state.selectorsValues, (folderSelector) => {
        if (folderSelector.emailAccounts) {
          folderSelector.emailAccounts.forEach((em) => {
            if (em.email_address === emailName) {
              formattedData[em.email_code] = data.email_names[emailName];
            }
          });
        }
      });
    });

    if (Object.keys(formattedData).length === 0) {
      setFormErrors({
        onForm: "Delegate must have at least one email account",
      });
      return false;
    } else {
      setFormErrors({}, true);
    }

    this.state.api
      .editDelegate(delegateCode, {
        ...formData,
        email_codes: { ...formattedData },
      })
      .then(() => {
        refreshDelegate();
        alertSuccess(t("alert.delegateUpdatedSuccess"));
        unsetFormLoading();
      })
      .catch((response) => {
        formatServerErrors(response).then((errors) => {
          setFormErrors(errors);
          unsetFormLoading();
        });
      });
  }

  toggleNoExpiration(val) {
    if (val.no_expiration) {
      this.props.setFormFieldValue({
        expiration: undefined,
        no_expiration: true,
      });
    } else {
      this.props.setFormFieldValue(val);
    }
  }

  toggleAlways(val) {
    if (val.always) {
      this.props.setFormFieldValue({
        visualization_start: undefined,
        visualization_end: undefined,
        always: true,
      });
    } else {
      this.props.setFormFieldValue(val);
    }
  }

  updateStartDate(val) {
    if (val.visualization_start && this.props.formData.visualization_end) {
      let start = new XDate(val.visualization_start);
      let end = new XDate(this.props.formData.visualization_end);
      if (start.diffDays(end) < 0) {
        val.visualization_end = undefined;
      }
    }

    this.props.setFormFieldValue(val);
  }

  updateExpiration(val) {
    if (val.expiration && this.props.formData.visualization_end) {
      let expiration = new XDate(val.expiration);
      let end = new XDate(this.props.formData.visualization_end);
      if (expiration.diffDays(end) > 0) {
        val.visualization_end = undefined;
      }
    }

    this.props.setFormFieldValue(val);
  }

  sendResetPwdEmail() {
    const {
      match: {
        params: { delegateCode },
      },
    } = this.props;
    this.setState({ resetPwdEmailSent: true });
    this.state.api.createDelegatePasswordResetRequest(delegateCode);
  }

  render() {
    const { formData, setFormFieldValue, delegate, isFormLoading, formErrors } = this.props;
    const { tomorrow, folderMapperValues, selectorsValues, organizedResources, resetPwdEmailSent } = this.state;

    return (
      <div className={s.settingsDelegate}>
        <div className={s.wrapInfoBtn}>
          <div className={s.warnignMsg}>
            {!this.props.areFieldsPristine(
              "expiration",
              "no_expiration",
              "always",
              "visualization_start",
              "visualization_end",
              "domain"
            ) && <WarningBanner color="yellow-text" msg={t("infoMsg.unsaveChanged")} />}
          </div>
          <div className={s.infoBtnGroup}>
            <Button docsKey="delegates_settings" color="docs" type="button">
              button.docs
            </Button>
            <Button type="submit" onClick={this.submitForm} loading={isFormLoading}>
              button.save
            </Button>
          </div>
        </div>
        <div className={s.settings}>
          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.password.title")}</div>
              <div className="sectionDesc">{t("settings.sections.password.desc.delegate")}</div>
            </div>
            <div className="formsSectionSP">
              {resetPwdEmailSent && (
                <div className={cx("inputFull2", s.infoText)}>
                  <TranslatedString
                    subs={{
                      emailDelegate: delegate.email_address,
                    }}
                  >
                    description.text.delegate.recoveryPassword.email
                  </TranslatedString>
                </div>
              )}
              {!resetPwdEmailSent && (
                <div className={cx("inputFull2", s.infoText)}>
                  <TranslatedString
                    subs={{
                      emailDelegate: delegate.email_address,
                    }}
                  >
                    description.text.delegate.recoveryPassword
                  </TranslatedString>
                </div>
              )}
              {!resetPwdEmailSent && (
                <div className="inputFull2">
                  <Button color="outline" onClick={this.sendResetPwdEmail}>
                    button.passwordRecovery
                  </Button>
                </div>
              )}
            </div>
          </div>

          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.limits.time.title")}</div>
              <div className="sectionDesc">{t("settings.sections.limits.time.desc")}</div>
            </div>
            <div className="formsSectionSP">
              <Checkbox
                className="inputFull2"
                label={t("input.label.authorization.noExpiration")}
                name="no_expiration"
                checked={formData.no_expiration}
                onChange={this.toggleNoExpiration}
              />

              <DayPicker
                className={cx("inputFull2", "inputAddMargin")}
                label={t("input.label.authorization.expiration")}
                name="expiration"
                value={formData.expiration}
                minDate={tomorrow}
                onChange={this.updateExpiration}
                disabled={formData.no_expiration}
              />

              <Checkbox
                className="inputFull2"
                label={t("input.label.visualization.always")}
                name="always"
                checked={formData.always}
                onChange={this.toggleAlways}
              />

              <DayPicker
                label={t("input.label.visualization.start")}
                name="visualization_start"
                value={formData.visualization_start}
                onChange={this.updateStartDate}
                maxDate={formData.expiration}
                errors={formErrors.visualization_start}
                disabled={formData.always}
              />

              <DayPicker
                label={t("input.label.visualization.end")}
                name="visualization_end"
                value={formData.visualization_end}
                minDate={formData.visualization_start}
                maxDate={formData.expiration}
                onChange={setFormFieldValue}
                errors={formErrors.visualization_end}
                disabled={formData.always}
              />
            </div>
          </div>

          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.limits.access.title")}</div>
              <div className="sectionDesc">
                <TranslatedString>settings.sections.limits.access.desc</TranslatedString>
              </div>
            </div>
            <div className="formsSectionSP">
              {formErrors.onForm && (
                <div className="inputFull2">
                  <WarningBanner msg={formErrors.onForm} color="red" />
                </div>
              )}
              <div className="inputFull2">
                {_.map(selectorsValues, ({ domainCode, emailAccounts, isLoadingEmails }, selectorId) => {
                  return (
                    <div className={s.wrapDomains} key={domainCode}>
                      <DomainSelect
                        initialValue={domainCode}
                        label={t("label.domain")}
                        ref={(el) => (this.selectElements[selectorId] = el)}
                        name="domain"
                        customer_code={delegate.customer_code}
                        archive
                        onChange={(val) => this.selectDomainAndLoadEmails(val.domain, selectorId)}
                        disabledIf={(dom) => Object.keys(organizedResources).includes(dom.code)}
                      />

                      {!domainCode && <div className={s.box}>{t("input.placeholder.domain.select")}</div>}

                      {domainCode && !isLoadingEmails && (
                        <FolderMapper
                          showInboxFirst={false}
                          className={s.folderMapper}
                          folderNames={_.map(emailAccounts, (em) => em.email_address)}
                          itemsLabel={t("folderMapper.label.accounts")}
                          allItems={t("folderMapper.label.all.accounts")}
                          destinations={["subject", "full", "ignore"]}
                          destinationLabels={[
                            t("folderMapper.label.subject"),
                            t("folderMapper.label.full"),
                            t("folderMapper.label.ignore"),
                          ]}
                          defaultSelection="ignore"
                          initialValues={folderMapperValues[domainCode]}
                          ref={(el) => (this.mapperElements[selectorId] = el)}
                          isLoading={isLoadingEmails}
                        />
                      )}
                    </div>
                  );
                })}
              </div>

              <Button color="outline" onClick={this.newDomainSelector}>
                button.addDomain
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
